/* eslint-disable promise/param-names */
import { GET_CHART_STATUS, GET_CHART_POINT_STATUS, GET_CHART_ALARME, GET_CHART_SENSOR_STATUS, GET_CHART_NODE_STATUS, GET_CHART_SENSOR_BATTERY, TIPO_ERROR } from '../actions/chartsOnline'
import axios from 'axios'

const state = {
  onlineStatus: [],
  onlinePointStatus: [],
  onlineAlarme: [],
  onlineSensorStatus: [],
  onlineNodeStatus: [],
  onlineSensorBattery: [],

}

const getters = {
  onlineStatus: state => state.onlineStatus,
  onlinePointStatus: state => state.onlinePointStatus,
  onlineAlarme: state => state.onlineAlarme,
  onlineSensorStatus: state => state.onlineSensorStatus,
  onlineNodeStatus: state => state.onlineNodeStatus,
  onlineSensorBattery: state => state.onlineSensorBattery,

}

const API = process.env.ROOT_API
const ENDPOINT = 'v1/get-equip-status'
const ENDPOINT_STATUS_ALARME = 'v1/get-sensor-status-alarme'
const ENDPOINT_ALARME = 'v1/get-sensor-status-alarme-24'
const ENDPOINT_SENSOR_STATUS = 'v1/get-sensor-status'
const ENDPOINT_NODE_STATUS = 'v1/get-nodo-status'
const ENDPOINT_SENSOR_BATTERY = 'v1/get-bateria-status'


const actions = {
  [GET_CHART_STATUS]: ({commit, dispatch}, user) => {
    console.log('user: ', user)
    return new Promise((resolve, reject) => {
      console.log('TOKEN', localStorage.getItem('user-token'))
      commit(GET_CHART_STATUS)
      axios({method: 'GET', url: API + ENDPOINT, params: user, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
      .then(resp => {
        console.log('API GET_CHART_STATUS :', resp.data.result)
        let res = resp.data.result
        commit(GET_CHART_STATUS, res)
        resolve(res)
      })
      .catch(err => {
        commit(TIPO_ERROR, err)
        reject(err)
      })
    })
  },
  [GET_CHART_POINT_STATUS]: ({commit, dispatch}, user) => {
    console.log('user: ', user)
    return new Promise((resolve, reject) => {
      console.log('TOKEN', localStorage.getItem('user-token'))
      commit(GET_CHART_POINT_STATUS)
      axios({method: 'GET', url: API + ENDPOINT_STATUS_ALARME, params: user, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
      .then(resp => {
        console.log('API GET_CHART_POINT_STATUS :', resp.data.result)
        let res = resp.data.result
        commit(GET_CHART_POINT_STATUS, res)
        resolve(res)
      })
      .catch(err => {
        commit(TIPO_ERROR, err)
        reject(err)
      })
    })
  },
  [GET_CHART_ALARME]: ({commit, dispatch}, user) => {
    console.log('user: ', user)
    return new Promise((resolve, reject) => {
      console.log('TOKEN', localStorage.getItem('user-token'))
      commit(GET_CHART_ALARME)
      axios({method: 'GET', url: API + ENDPOINT_ALARME, params: user, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
      .then(resp => {
        console.log('API GET_CHART_ALARME :', resp.data.result)
        let res = resp.data.result
        commit(GET_CHART_ALARME, res)
        resolve(res)
      })
      .catch(err => {
        commit(TIPO_ERROR, err)
        reject(err)
      })
    })
  },
  [GET_CHART_SENSOR_STATUS]: ({commit, dispatch}, user) => {
    console.log('user: ', user)
    return new Promise((resolve, reject) => {
      console.log('TOKEN', localStorage.getItem('user-token'))
      commit(GET_CHART_SENSOR_STATUS)
      axios({method: 'GET', url: API + ENDPOINT_SENSOR_STATUS, params: user, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
      .then(resp => {
        console.log('API GET_CHART_SENSOR_STATUS :', resp.data.result)
        let res = resp.data.result
        commit(GET_CHART_SENSOR_STATUS, res)
        resolve(res)
      })
      .catch(err => {
        commit(TIPO_ERROR, err)
        reject(err)
      })
    })
  },
  [GET_CHART_NODE_STATUS]: ({commit, dispatch}, user) => {
    console.log('user: ', user)
    return new Promise((resolve, reject) => {
      console.log('TOKEN', localStorage.getItem('user-token'))
      commit(GET_CHART_NODE_STATUS)
      axios({method: 'GET', url: API + ENDPOINT_NODE_STATUS, params: user, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
      .then(resp => {
        console.log('API GET_CHART_NODE_STATUS :', resp.data.result)
        let res = resp.data.result
        commit(GET_CHART_NODE_STATUS, res)
        resolve(res)
      })
      .catch(err => {
        commit(TIPO_ERROR, err)
        reject(err)
      })
    })
  },
  [GET_CHART_SENSOR_BATTERY]: ({commit, dispatch}, user) => {
    console.log('user: ', user)
    return new Promise((resolve, reject) => {
      console.log('TOKEN', localStorage.getItem('user-token'))
      commit(GET_CHART_SENSOR_BATTERY)
      axios({method: 'GET', url: API + ENDPOINT_SENSOR_BATTERY, params: user, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
      .then(resp => {
        console.log('API GET_CHART_SENSOR_BATTERY :', resp.data.result)
        let res = resp.data.result
        commit(GET_CHART_SENSOR_BATTERY, res)
        resolve(res)
      })
      .catch(err => {
        commit(TIPO_ERROR, err)
        reject(err)
      })
    })
  },
  
  
}

const mutations = {
  [GET_CHART_STATUS]: (state, res) => {
    state.onlineStatus = res
  },
  [GET_CHART_POINT_STATUS]: (state, res) => {
    state.onlinePointStatus = res
  },
  [GET_CHART_ALARME]: (state, res) => {
    state.onlineAlarme = res
  },
  [GET_CHART_SENSOR_STATUS]: (state, res) => {
    state.onlineSensorStatus = res
  },
  [GET_CHART_NODE_STATUS]: (state, res) => {
    state.onlineNodeStatus = res
  },
  [GET_CHART_SENSOR_BATTERY]: (state, res) => {
    state.onlineSensorBattery = res
  },
  
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/chartsOnline.js